import state from './state'
import mutation from './mutation'
import actions from './actions'
import getters from './getters'

const CustomerPaymentModule = {
    namespaced: true,
    state: state,
    mutations: mutation,
    actions: actions,
    getters: getters,
}

export default CustomerPaymentModule